import React from "react";

const icon = props => {
    return <i className={["icon", props.type].join(" ")}></i>;
};

export default icon;
